(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter-range"] && !Shopify.designMode) return;
  try {
    class PriceRangeComponent extends HTMLElement {
    connectedCallback() {
      this.minSlider = this.querySelector('[ref="minSlider"]');
      this.maxSlider = this.querySelector('[ref="maxSlider"]');
      this.minInput = this.querySelector('[ref="minInput"]');
      this.maxInput = this.querySelector('[ref="maxInput"]');
      this.minValue = this.querySelector('[ref="minValue"]');
      this.maxValue = this.querySelector('[ref="maxValue"]');
      this.trackActive = this.querySelector('[ref="trackActive"]');

      this.min = Number(this.dataset.min) || 0;
      this.max = Number(this.dataset.max) || 0;
      this.currentMin = Number(this.dataset.currentMin) || this.min;
      this.currentMax = Number(this.dataset.currentMax) || this.max;
      this.currency = this.dataset.currency || '$';
      this.debounceTimer = null;

      // Initialize hidden inputs with current filter values (in dollars - Shopify expects dollars, not cents)
      if (this.minInput) {
        this.minInput.value = (this.currentMin > this.min) ? this.currentMin : '';
      }
      if (this.maxInput) {
        this.maxInput.value = (this.currentMax < this.max) ? this.currentMax : '';
      }

      if (this.minSlider) {
        this.minSlider.addEventListener('input', () => this.handleSliderInput());
        this.minSlider.addEventListener('change', () => this.handleSliderChange());
      }
      if (this.maxSlider) {
        this.maxSlider.addEventListener('input', () => this.handleSliderInput());
        this.maxSlider.addEventListener('change', () => this.handleSliderChange());
      }

      this.updateTrack();
    }

    // Called on every input event (while dragging)
    // Updates display and track visually
    handleSliderInput() {
      let minVal = Number(this.minSlider.value) || 0;
      let maxVal = Number(this.maxSlider.value) || 0;

      // Prevent min from exceeding max
      if (minVal > maxVal - 1) {
        minVal = maxVal - 1;
        this.minSlider.value = minVal;
      }
      // Prevent max from going below min
      if (maxVal < minVal + 1) {
        maxVal = minVal + 1;
        this.maxSlider.value = maxVal;
      }

      // Update display
      if (this.minValue) this.minValue.textContent = this.currency + Math.floor(minVal);
      if (this.maxValue) this.maxValue.textContent = this.currency + Math.floor(maxVal);

      // Update track
      this.updateTrackFromValues(minVal, maxVal);

      // Update hidden inputs - Shopify expects dollars, not cents
      this.minInput.value = (minVal > this.min) ? minVal : '';
      this.maxInput.value = (maxVal < this.max) ? maxVal : '';
    }

    // Called when slider is released - triggers the filter update with debounce
    handleSliderChange() {
      // Clear any existing debounce timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // Debounce the filter update by 500ms
      this.debounceTimer = setTimeout(() => {
        // Dispatch a change event that bubbles up to trigger the filter update
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }, 500);
    }

    updateTrackFromValues(minVal, maxVal) {
      const range = this.max - this.min;
      if (range > 0 && this.trackActive) {
        const minPercent = ((minVal - this.min) / range) * 100;
        const maxPercent = ((maxVal - this.min) / range) * 100;
        this.trackActive.style.left = minPercent + '%';
        this.trackActive.style.width = (maxPercent - minPercent) + '%';
      }
    }

    updateTrack() {
      const minVal = Number(this.minSlider.value) || 0;
      const maxVal = Number(this.maxSlider.value) || 0;
      this.updateTrackFromValues(minVal, maxVal);
    }
  }

  if (!customElements.get('price-range-component')) {
    customElements.define('price-range-component', PriceRangeComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-dropdown"] && !Shopify.designMode) return;
  try {
    class SearchDropdown extends HTMLElement {
    constructor() {
      super();
      this.searchButton = this.querySelector('[ref="searchButton"]');
      this.searchDropdown = this.querySelector('[ref="searchDropdown"]');
      this.isOpen = false;
      this.animationDelay = parseInt(this.dataset.animationDelay) || 200;
      this.resizeObserver = null;
    }

    connectedCallback() {
      this.searchButton.addEventListener('click', this.toggleSearch.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
      document.addEventListener('keydown', this.handleEscape.bind(this));

      // Watch for content changes and update height
      const innerContent = this.searchDropdown.querySelector('.search-dropdown__inner');
      if (innerContent) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.isOpen) {
            this.updateHeight();
          }
        });
        this.resizeObserver.observe(innerContent);
      }
    }

    disconnectedCallback() {
      this.searchButton.removeEventListener('click', this.toggleSearch.bind(this));
      document.removeEventListener('click', this.handleClickOutside.bind(this));
      document.removeEventListener('keydown', this.handleEscape.bind(this));
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    updateHeight() {
      const innerHeight = this.searchDropdown.querySelector('.search-dropdown__inner').offsetHeight;
      this.searchDropdown.style.setProperty('--submenu-height', `${innerHeight}px`);
    }

    toggleSearch(event) {
      event.stopPropagation();

      if (this.isOpen) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    }

    openSearch() {
      this.isOpen = true;

      // Calculate height for animation
      this.updateHeight();

      this.setAttribute('data-open', 'true');
      this.searchButton.setAttribute('aria-expanded', 'true');

      // Focus search input
      setTimeout(() => {
        const input = this.querySelector('input[type="search"]');
        if (input) input.focus();
      }, this.animationDelay);
    }

    closeSearch() {
      this.setAttribute('data-animating', 'true');

      setTimeout(() => {
        this.isOpen = false;
        this.removeAttribute('data-open');
        this.removeAttribute('data-animating');
        this.searchButton.setAttribute('aria-expanded', 'false');
      }, this.animationDelay);
    }

    handleClickOutside(event) {
      if (!this.contains(event.target) && this.isOpen) {
        this.closeSearch();
      }
    }

    handleEscape(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.closeSearch();
      }
    }
  }

  if (!customElements.get('search-dropdown')) {
    customElements.define('search-dropdown', SearchDropdown);
  }
  } catch(e) { console.error(e); }
})();

})();
